import { defineMessages } from 'react-intl';

export default defineMessages({
  createIssuesInOtherProjects: {
    id: 'frontbucket.createJiraIssueJiraTab.createIssuesInOtherProjects',
    description:
      'Instructions for how users can create Jira issues in projects which are not currently displayed',
    defaultMessage: `To create issues in other projects, link them to this repository or {createInJiraLink}.`,
  },
  goToJira: {
    id: 'frontbucket.createJiraIssueJiraTab.goToJira',
    description: 'Text for the link to Jira',
    defaultMessage: `go to Jira`,
  },
  projectsHeader: {
    id: 'frontbucket.createJiraIssueJiraTab.projectsHeader',
    description: 'Header text for the Jira projects dropdown',
    defaultMessage: 'Linked projects',
  },
});
